<template>
  <b-card class="mb-5 journal-style">
    <b-row class="mb-2">
      <b-col md="6">
        <h3>{{ $route.name }}</h3>

        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>

      <b-col md="6">
        <b-button variant="primary" class="float-right btn-custom mt-3" :to="'journal/create'"
          ><font-awesome-icon icon="plus"
        /></b-button>
      </b-col>
    </b-row>
    <div class="border-bottom"></div>

    <b-row class="mt-3">
      <b-col md="12" lg="12">
        <div class="table-responsive w-100 table-striped">
          <table>
            <thead class="table-bordered text-center">
              <tr>
                <th width="180">No Transaction</th>
                <th width="140">Date</th>
                <th width="120">Acc Code</th>
                <th width="250">Account Name</th>
                <th width="364">Description</th>
                <th width="180">Debit</th>
                <th width="180">Credit</th>
                <th></th>
              </tr>
            </thead>
            <div v-if="isLoading">
           <div class="text-center" style="margin: 3% auto;">
               <b-spinner small type="grow" label="Small Spinner"></b-spinner>
               <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
               <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
           </div>
          </div>
            <tbody v-else class="table-bordered mt-3">
              <tr v-for="journal in model.journals" :key="journal.uuid" class="mt-2">
                <!-- no transaction -->
                <td width="180">
                  <p>
                  {{journal.no !==null ? journal.no : '-'}}
                  </p>
                </td>
                <td width="140">
                  <p class="text-center">
                  {{journal.date !==null ? new Date(journal.date).toLocaleDateString() : '-'}}
                  </p>
                </td>
                <td width="120" >
                  <div v-for="tran in journal.transaction" :key="tran.uuid">
                    <p class="m-0 p-0 text-center">
                  {{tran.account !== null ? tran.account.journalAccountCode : '-'}}
                    </p>
                  </div>
                </td>
                <td width="250">
                  <div v-for="tran in journal.transaction" :key="tran.uuid">
                    <p class="m-0 p-0">
                    {{tran.account !== null ? tran.account.journalAccountName : '-'}}
                    </p>
                  </div>
                </td>
                <td width="364">
                  <div v-for="tran in journal.transaction" :key="tran.uuid" class="d-flex font-weight-light">
                     {{tran.note}}
                  </div>
                </td>
                <td width="120" class="money">
                  <div v-for="tran in journal.transaction" :key="tran.uuid" class="text-right">
                      {{formatPrice(tran.debit)}}
                  </div>
                </td>
                <td width="120" class="money">
                  <div v-for="tran in journal.transaction" :key="tran.uuid" class="text-right">
                      {{formatPrice(tran.credit)}}
                  </div>
                </td>
                <td width="40" class="text-center">
                  <a
                        v-if="canShowRoutePath"
                        v-b-tooltip.hover.left
                        title="Details"
                        class="btn-op icon-info mr-1"
                        :href="'/#/accounting/journal' + '/' + journal.uuid"
                      ></a>
                      <a
                        v-else
                        v-b-tooltip.hover.left
                        title="Details"
                        class="btn-op icon-info mr-1"
                        :href="'#' + $route.path + '/' + journal.uuid"
                      ></a>
                  <!-- <b-icon icon="exclamation-circle-fill" variant="primary" class="pointer"></b-icon> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
      <b-col>

      </b-col>
    </b-row>
    <b-row>
      <b-col md="7"></b-col>
      <b-col md="3">   </b-col>
      <b-col md="2">
        <div class="d-flex" style="align-items: center;">
          <div></div>
          <b-button @click="model.paginate --" v-if="buttonPrev" size="sm" 
           variant="info" class="mt-3 mr-3">prev</b-button> <p class="mt-4"> {{page}} / {{pageSize}} </p> 
          <b-button @click="model.paginate ++" v-if="buttonNext" size="sm" variant="info" class="mt-3 ml-3"> next</b-button>
          </div>
      </b-col>
    </b-row>

    <!-- search box filter -->

    <!-- end search  -->

    <!-- table paginate -->

    <!-- end table -->
  </b-card>
</template>

<script>
export default {
  name: 'report-index',

  components: {},

  data() {
    return {
      isLoading: false,
      buttonPrev: false,
      buttonNext: true,
      // rows: 0,
      currentPage: 1,
      pageSize: '-' ,
      page: 1,
      perPage: 10,
      index: 0,
      apiUrl: {
        journal: window.AppConfig.apiUrl + 'journal',
      },
      model:{
        journals: [],
        paginate: 1,
      },
      canShowRoutePath: {
        type: String,
        required: false,
        default: '',
      },
    };
  },

  watch: {
    'model.paginate'(value){
        this.getJournalData(value)
    }
  },

  mounted() {
      this.getJournalData()
  },

  methods: {
    /** get data journal from API */
     getJournalData(pages){
       this.isLoading = true
       if(pages === undefined){
         this.$http.get(this.apiUrl.journal + '?limit=' + this.perPage + '&page=1').then((response)=> {
         this.model.journals = response.data._embedded.journal.map((p) => ({
          no: p.journalNumberTransaction,
          date: p.journalDate,
          uuid: p.uuid,
          transaction: p.journalTransaction.map(transaction=>({
            debit: transaction.journalTransactionDebit,
            credit: transaction.journalTransactionCredit,
            note: transaction.journalTransactionNote,
            account: transaction.journalAccount
          }))
        }));
        this.isLoading = false
        this.rows = response.data.total_items
        console.log('response is:',this.model.journals);
      })
       } else {
         this.$http.get(this.apiUrl.journal + '?limit=' + this.perPage + '&page=' + pages).then((response)=> {
           this.model.journals = response.data._embedded.journal.map((p) => ({
             no: p.journalNumberTransaction,
             date: p.journalDate,
             uuid: p.uuid,
             transaction: p.journalTransaction.map(transaction=>({
               debit: transaction.journalTransactionDebit,
               credit: transaction.journalTransactionCredit,
               note: transaction.journalTransactionNote,
               account: transaction.journalAccount
             }))
           }));
           this.rows = response.data.total_items
           this.pageSize = response.data.page_count
           this.page = response.data.page
           if(this.model.paginate === response.data.page_count){
             this.buttonNext = false;
             this.buttonPrev = true
           } else if (this.model.paginate === 1) {
             this.buttonPrev = false
             this.buttonNext = true
           } else {
             this.buttonPrev = true
             this.buttonNext = true
           }
           console.log('response is:',this.model.journals);
           this.isLoading = false
         })
         
       }
    },

    doFilter() {
      //
    },

    clearFilter() {
      //
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm');
      } else {
        return '-';
      }
    },

    /** colores status  */
    getStatusColor(val) {
      switch (val) {
        case 'Requested':
          return 'warning';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Resolved':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
  },
};
</script>

<style scoped>
.journal-style{
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px !important;
}

.money {
  font-family: 'Courier New', Courier, monospace;
}
</style>
